export default {
  translation: {
    common: {
      accept: 'Qabul qilish',
      alreadyUser: 'Allaqachon foydalanuvchimisiz?',
      and: 'va',
      backToLogin: 'Kirish sahifasiga qaytish',
      continueWith: '{{provider}} bilan davom etish',
      coreNotFound: "Asosiy sozlamalarni yuklab bo'lmadi",
      createAccount: 'Hisob yaratish',
      createYourAccount: 'Hisobingizni yarating',
      emailOrUsername: 'Email yoki foydalanuvchi nomi',
      invalidUsernameOrPassword: "Notog'ri foydalanuvchi nomi yoki parol",
      localRegistrationDisabled: "Mahalliy ro'yxatdan o'tish administrator tomonidan o'chirilgan",
      login: 'Kirish',
      logInToBoards: 'Kirish',
      newToBoards: '4ga Boardsda yangimisiz?',
      noInternetConnection: "Internet aloqasi yo'q",
      pageNotFound_title: 'Sahifa topilmadi',
      password: 'Parol',
      policyNotAccepted: 'Iltimos, Xizmat shartlari va Maxfiylik siyosatini qabul qiling',
      privacyPolicy: 'Maxfiylik siyosati',
      register: "Ro'yxatdan o'tish",
      registerWithGoogle: "Google orqali ro'yxatdan o'tish",
      registrationDisabled: "Foydalanuvchi ro'yxatdan o'tishi administrator tomonidan o'chirilgan",
      serverConnectionFailed: 'Serverga ulanish muvaffaqiyatsiz',
      ssoRegistrationDisabled: "SSO ro'yxatdan o'tish administrator tomonidan o'chirilgan",
      termsOfService: 'Xizmat shartlari',
      togglePasswordVisibility: "Parolni ko'rsatish/yashirish",
      unknownError: "Noma'lum xato, keyinroq qayta urinib ko'ring",
    },

    action: {
      logIn: 'Kirish',
    },
  },
};
